const PUBLIC_IMAGE_HOSTS = ['illustration-photos', 'raw.githubusercontent.com'];

/** Public images are loaded directly by the browser, not through the authenticated blob proxy. */
export function isPublicImageUrl(url: string | undefined | null): boolean {
  return !!url && PUBLIC_IMAGE_HOSTS.some(host => url.includes(host));
}
